import gql from "graphql-tag";
import {
  TextAndMedia as TextAndMediaProps,
} from "../../../../__generated__/graphql";
import { ContentfulComponentType } from "../types";
import styles from "./TextAndMedia.module.css";
import TextFieldsV2 from "../TextFieldsV2";
import Gutter from "ui-kit/Gutter";
import { ContentfulC2A } from "../ContentfulC2A";
import List, { ListStyleEnum } from "../List";
import ContentfulMedia from "components-shared/ContentfulMedia";
import classNames from "classnames";

export const ContentfulTextAndMedia: ContentfulComponentType<
  TextAndMediaProps & {
    isRedesign?: boolean;
    imageObjectFit?: "cover" | "contain";
    narrowText?: boolean;
  }
> = ({
  layout,
  media,
  title,
  text,
  intro,
  listItemsCollection,
  listLayout,
  listStyle,
  c2A,
  isRedesign,
  imageObjectFit,
  narrowText,
}) => {
  const listItems = listItemsCollection?.items ?? [];
  return (
    <div
      className={classNames(
        layout! ? styles.container : styles.containerReverse,
        isRedesign && styles.newDesign,
        "container",
      )}
    >
      <div className={styles.mediaContainer}>
        <ContentfulMedia
          media={media}
          sizes="(max-width: 768px) 100vw, (max-width: 1080px) 40vw, 476px"
          display="square"
          objectFit={imageObjectFit}
        />
      </div>
      <div
        className={classNames(
          styles.textContainer,
          narrowText && styles.narrowText,
        )}
      >
        <TextFieldsV2
          title={title}
          text={text}
          intro={intro}
          variantText="bodyRg"
          gutterBottom={0}
        />
        {listItems.length > 0 && (
          <>
            <Gutter size={3} />
            <List
              items={listItems}
              listStyle={listStyle as ListStyleEnum}
              collapsible={!!listLayout}
            />
          </>
        )}
        {!!c2A && (
          <>
            <Gutter size={4} />
            <ContentfulC2A {...c2A} />
          </>
        )}
      </div>
    </div>
  );
};

ContentfulTextAndMedia.fragment = gql`
  fragment TextAndMedia on ComponentTextAndMedia {
    highlight
    title
    intro
    text
    theme
    layout
    listItemsCollection(limit: 10) {
      items {
        title
        text
        icon
      }
    }
    listLayout
    listStyle
    c2A {
      ...C2A
    }
    media {
      title
      url
      height
      width
      contentType
    }
    sys {
      id
      publishedAt
    }
  }
`;
